import React from 'react';

import { MainWrapper } from '../main-wrapper';
import { MiniModalLoadingContent } from './MiniModalLoadingContent';

export const MiniModalLoadingFallbackComponent = ({
	topOffset,
	isNav4Enabled,
}: {
	topOffset: number;
	isNav4Enabled: boolean;
}): JSX.Element => {
	return (
		<MainWrapper mode="mini-modal" isNav4Enabled={isNav4Enabled}>
			<MiniModalLoadingContent topOffset={topOffset} />
		</MainWrapper>
	);
};
